import React from 'react';
import ReactHighcharts from 'react-highcharts';
import { useTranslation } from 'react-i18next';

export default React.memo(function ProgressChart(props) {
    const { shouldShowChart, reportConfig, progressChartRef, i18n } = props;

    const { t } = useTranslation(['teacher_report_chart_progress'], {i18n})

    ReactHighcharts.Highcharts.setOptions({
        lang: {
            shortMonths: [t("Jan"), t("Feb"), t("Mar"), t("Apr"), t("May"), t("Jun"), t("Jul"), t("Aug"), t("Sep"), t("Oct"), t("Nov"), t("Dec")]
        }
    })
    
    if (!shouldShowChart) return null
    if (!reportConfig) return null

    return <div className="progressHighchartsContainer">
      <ReactHighcharts isPureConfig={true} config={reportConfig} ref={progressChartRef} />
    </div>
})